import React from 'react';

import SvgNotFound from './icon.svg';

const NotFound = props => <SvgNotFound {...props} />;

export default NotFound;
